export async function defaultFetchErrorFn(resp: Response): Promise<Error> {
  // return `Could not fetch ${res.url} resource: ${res.status}`
  // return new Error(`Could not fetch ${res.url}: returned ${res.status}`)
  return new Error(`could not fetch resource (${resp.url}): ${resp.status} ${resp.statusText}`, {
    cause: new Error(`remote: ${await resp.text()}`)
    // cause: { body: await resp.text() }
  })
}


// type ErrorResponse = {

// }

// export async function handleFetchError(result: Promise<Response>, options?: {
//   msgFn: (res: Response) => string
//   errorFilter: ()
// }): Promise<Response> {
//   const msgFn = options?.msgFn ?? defaultFetchErrorFn
//   const errorFilter = options?.errorFilter ?? () => true
//   const resp = await result
//   if (!resp.ok) throw new Error(msgFn(resp))

//   return resp
// }

export async function handleFetchError(result: Promise<Response>, msgFn: (res: Response) => Promise<Error> = defaultFetchErrorFn): Promise<Response> {
  const resp = await result
  if (!resp.ok) throw await msgFn(resp)

  return resp
}
